import { create } from "zustand";
import { api } from "@/services/api.service";

export type GameStat = {
  id: string;
  totalWinningAmount: number;
  wageredAmount: number;
  isWin: boolean;
  updatedAt: string;
  profit: number;
  cumulativeProfit: number;
};

export type GameStats = {
  stats: GameStat[];
  wins: number;
  losses: number;
  totalProfit: number;
  totalWageredAmount: number;
};

export type GameStatsStore = {
  stats: GameStats | null;
  refreshStats: () => void;
  startTime: string;
  resetStartTime: () => void;
  hold: boolean;
  setHold: (hold: boolean) => void;
  isLiveStatsModelOpen: boolean;
  setIsLiveStatsModelOpen: (value: boolean) => void;
};

const useGameStatsStore = create<GameStatsStore>((set, get) => ({
  stats: null,
  hold: false,
  startTime: new Date().toISOString(),
  isLiveStatsModelOpen: false,
  setIsLiveStatsModelOpen: (value) => set({ isLiveStatsModelOpen: value }),
  refreshStats: () => {
    const startTime = get().startTime;
    if (get().hold) return; // Prevent refreshing if hold is true
    api
      .get(`/games/stats?startTime=${startTime}`)
      .then((response) => {
        console.log("response", response);
        set({ stats: response?.data?.data });
      })
      .catch((error) => {
        console.log(error);
      });
  },
  resetStartTime: () => {
    set({ startTime: new Date().toISOString(), stats: null });
  },
  setHold: (hold: boolean) => {
    // Ensure refreshStats is only called when hold is set to false
    if (!hold) {
      get().refreshStats();
    }
    set({ hold });
  },
}));

export default useGameStatsStore;
